<script>
    import { user } from "../user/user.state.svelte.js";
    import { format, locale } from "svelte-i18n";
    import BreadcrumNav from "../../components/breadcrum-nav.svelte";
    import { notificate } from "../../services/notification";
    import workspaceService from '../../services/workspace.js';

    let show_message = $state(false);

    const handlePentestSolicit = async () => {
        let result = await notificate('confirm_pentest', "modal", {});
        if (!result.isConfirmed) {
            return false;
        }

        workspaceService.pentestSolicit()
            .then((r)=>{
                show_message = true;
                notificate("request_ok")
            })
            .catch(error=>{
                return notificate("500");
            })
        ;
    }
</script>


<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <img src="/img/icon-swords.png" alt="" style="max-width: 22px;" />
                    {$format("layout.sidebar.pentest")}
                </h1>
            </div>
            <div class="col-6">
                <BreadcrumNav
                    routes={[{ label: $format("components.breadcrumb.me") }]}
                />
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <section class="pentest-section">
                        <header class="pentest-header">
                            <h2>
                                {$format("page.pentest.title")}
                            </h2>
                            <p>
                                {@html $format("page.pentest.description")}
                            </p>
                        </header>

                        <div class="pentest-cards">
                            <article class="pentest-card black-box">
                                <h3>{$format("page.pentest.blackbox_title")}</h3>
                                <p>
                                    {$format("page.pentest.blackbox_description")}
                                </p>
                            </article>

                            <article class="pentest-card grey-box">
                                <h3>{$format("page.pentest.graybox_title")}</h3>
                                <p>
                                    {$format("page.pentest.graybox_description")}
                                </p>
                            </article>

                            <article class="pentest-card white-box">
                                <h3>{$format("page.pentest.whitebox_title")}</h3>
                                <p>
                                    {$format("page.pentest.whitebox_description")}
                                </p>
                            </article>
                        </div>

                        <div class="pentest-table-wrapper">
                            <table class="pentest-table">
                                <thead>
                                    <tr>
                                        <th>{$format("page.pentest.table.test_type")}</th>
                                        <th>{$format("page.pentest.table.access_level")}</th>
                                        <th>{$format("page.pentest.table.ideal_for")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Blackbox</td>
                                        <td>{$format("page.pentest.table.none")}</td>
                                        <td>{$format("page.pentest.table.real_attack")}</td
                                        >
                                    </tr>
                                    <tr>
                                        <td>Greybox</td>
                                        <td>{$format("page.pentest.table.partial")}</td>
                                        <td
                                            >{$format("page.pentest.table.limited_access")}</td
                                        >
                                    </tr>
                                    <tr>
                                        <td>Whitebox</td>
                                        <td>{$format("page.pentest.table.complete")}</td>
                                        <td
                                            >{$format("page.pentest.table.all_env")}</td
                                        >
                                    </tr>
                                </tbody>
                            </table>
                            <footer class="pentest-footer mt-3">
                                {#if user.data.role != "viewer"}
                                    <button class="btn btn-success mt-3" onclick={handlePentestSolicit}>{$format("buttons.pentest_friendly")}</button>
                                {:else}
                                    <div class="alert alert-info w-50" style="margin: 0 auto; text-align: left;">
                                        <h5><i class="icon fas fa-info"></i>{$format("page.plan.info")}</h5>
                                        {$format("page.plan.admin_message")}
                                    </div>
                                {/if}
                                {#if show_message}
                                    <div class="mt-3 alert alert-success">{$format("page.plan.request_success")}</div>
                                {/if}
                            </footer>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .pentest-section {
        max-width: 1280px;
        margin: 2rem auto;
        padding: 1rem;
        font-family: Arial, sans-serif;
        color: #444;
        line-height: 1.5;
    }

    .pentest-header {
        text-align: center;
        margin-bottom: 2rem;
    }

    .pentest-header h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #333;
        margin: 0;
    }

    .pentest-header p {
        color: #555;
        margin-top: 0.5rem;
        margin-bottom: 0;
    }

    .pentest-cards {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 2rem;
    }

    .pentest-card {
        flex: 1 1 30%;
        border: 1px solid #ccc;
        border-radius: 12px;
        padding: 1rem;
        box-sizing: border-box;
        background-color: #fff;
        transition: box-shadow 0.2s ease;
    }

    .pentest-card:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .pentest-card h3 {
        font-weight: 600;
        margin-bottom: 0.5rem;
    }

    .pentest-card.black-box {
        background-color: rgb(33, 37, 41);
        color: white;
    }

    .pentest-card.grey-box {
        background-color: #666;
        color: white;
    }

    .pentest-card.white-box {
        background-color: white;
        color: rgb(33, 37, 41);
    }

    .pentest-table-wrapper {
        overflow-x: auto;
        margin-bottom: 2rem;
    }

    .pentest-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.9rem;
        color: #333;
    }

    .pentest-table thead {
        background-color: #f3f4f6;
    }

    .pentest-table th,
    .pentest-table td {
        padding: 0.5rem;
        border: 1px solid #ccc;
        text-align: left;
        white-space: nowrap;
    }

    .pentest-footer {
        text-align: center;
        color: #555;
    }

    .pentest-footer p:first-child {
        font-weight: 600;
        color: #333;
        font-size: 1.1rem;
        margin-bottom: 0.25rem;
    }
</style>
